import {
  Component,
  HostBinding,
  HostListener,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { BaseConfig } from '../../common/config/config.adapter';
import { CalendarStore } from '../calendar.store';
import {
  CalendarEvent,
  CalendarEventMenu,
  eventMenus,
} from '../calendar.types';

@Component({
  selector: 'app-common-event-adapter',
  template: '',
  standalone: true,
})
export class CommonEventAdapter extends BaseConfig {
  @HostListener('click', ['$event']) onClick() {
    if (this.options()?.event?.selected) {
      this.store.eventClickEvent(this.event());
    }
  }

  @HostBinding('class') get hostClass() {
    if (this.options()?.event?.selected) {
      return 'cursor-pointer';
    }

    return '';
  }

  readonly store = inject(CalendarStore);
  options = this.store.options;

  event = input.required<CalendarEvent>();
  index = input.required<number>();

  isContextOpen = signal<boolean>(false);

  menu = output<CalendarEventMenu>();
  menus = eventMenus;
}
